import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16.5461 8.97827C14.8989 9.63717 12.7604 10 10.5 10C8.23963 10 6.10115 9.63717 4.45392 8.97827C3.94923 8.7764 3.45286 8.53173 3 8.23525V11.5C3 13.1569 6.35786 14.5 10.5 14.5C11.6041 14.5 12.6525 14.4046 13.5964 14.2332C14.6394 13.0355 16.1139 12.2236 17.7778 12.0397C17.813 12.0358 17.8484 12.0322 17.8838 12.0288C17.9602 11.8572 18 11.6804 18 11.5V8.23525C17.5471 8.53173 17.0508 8.7764 16.5461 8.97827Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.5 16.5C11.1255 16.5 11.7416 16.4722 12.3406 16.4181C12.1197 17.0717 12 17.7719 12 18.5C12 19.3465 12.1618 20.1552 12.4562 20.8969C11.8326 20.9641 11.1768 21 10.5 21C6.35786 21 3 19.6569 3 18V14.7352C3.45286 15.0317 3.94923 15.2764 4.45392 15.4783C6.10115 16.1372 8.23963 16.5 10.5 16.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.5 8C6.35786 8 3 6.65685 3 5C3 3.34315 6.35786 2 10.5 2C13.6066 2 16.2721 2.75552 17.4106 3.83226C17.7901 4.19118 18 4.58579 18 5C18 6.65685 14.6421 8 10.5 8Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.5 23C16.8151 23 15.3464 22.074 14.5752 20.7031C14.2089 20.0519 14 19.3003 14 18.5C14 16.1837 15.75 14.2762 18 14.0275C18.1642 14.0093 18.331 14 18.5 14C20.9853 14 23 16.0147 23 18.5C23 20.9853 20.9853 23 18.5 23Z"}}]};

const Wealth1Filled = Vue.extend<IconProps>({
  name: 'Wealth1FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'wealth-1-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Wealth1Filled;
